import GroupBase from "./GroupsBase";

class VisibilityGroup extends GroupBase {
    constructor() {
        super({
            name: "Visibility",
            description: "Metrics related to the visibility of your content.",
        });
    }
}

export default VisibilityGroup;
